/**
 * defa.collections.generic-state
 * A Collection of GenericStates
 * @version 1.0.0
 */
import GenericState from 'scripts/defa/control/generic-state/model-generic-state';

const GenericStates = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : GenericState,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default GenericStates;